import React from 'react';

const FAQ = () => {
  return (
    <div>
      This is the frequently asked question page.
    </div>
  );
};

export default FAQ;